import { useSelector } from '@redux';
import RestEdit from 'containers/rest/Edit';
import Form from '../components/Form';
import React from 'react';
import { DynamicObjectType } from 'types/commons';

const EditChainStore = () => {
  const data = useSelector<DynamicObjectType>(
    (state) => state.chainStores.currentData,
  );

  const breadcrumbs = [
    {
      title: 'common.page.brands',
      href: '/settings/chainStores',
    },
    {
      title: `#${data?.id}`,
    },
  ];

  return (
    <RestEdit model="chainStores" breadcrumbs={breadcrumbs}>
      <Form />
    </RestEdit>
  );
};

export default EditChainStore;
